import {
  Component,
  ComponentRef,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Type,
  ViewContainerRef,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'dh-custom-view',
    template: `
    <div [ngClass]="{ 'phone-icon-wrapper': !!isPhoneNumber && !!value, 'data-cell-wrapper': helpText }">
      @if (viewType) {
      } @else {
        <span>{{ value }}</span>
        @if (helpText) {
          <astral-popover [helpText]="helpText"></astral-popover>
        }
        @if (!!isPhoneNumber && !!value) {
          <div class="_controls" (click)="stopPropagation($event)">
            <a class="phone-icon" [href]="'tel:' + value"> </a>
          </div>
        }
      }
    </div>
    `,
    styleUrls: ['./data-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DataCellComponent implements OnInit, OnDestroy {
  constructor(
    private _e: ElementRef,
    private _host: ViewContainerRef
  ) {}

  @Input() viewType: Type<any>;
  @Input() value: any;
  @Input() helpText: any;
  @Input() isPhoneNumber: boolean;

  private _c: ComponentRef<any>;
  get hostWidth(): number {
    return this._e.nativeElement.offsetWidth;
  }

  ngOnDestroy() {
    if (this._c) {
      this._c.destroy();
      this._c = null;
    }
  }

  ngOnInit() {
    if (this.viewType) {
      this._c = this._host.createComponent(this.viewType);
      this._c.instance.dataContext = this.value;
    }
  }

  stopPropagation(e) {
    e.stopPropagation();
  }
}
